var map = {
	"./2022-08-28-advances": 4288,
	"./2022-08-28-advances.json": 4288,
	"./2022-08-28-controlled": 2501,
	"./2022-08-28-controlled.json": 2501,
	"./2022-08-28-ua": 1149,
	"./2022-08-28-ua.json": 1149,
	"./2022-09-06-advances": 2611,
	"./2022-09-06-advances.json": 2611,
	"./2022-09-06-controlled": 2062,
	"./2022-09-06-controlled.json": 2062,
	"./2022-09-06-ua": 934,
	"./2022-09-06-ua.json": 934,
	"./cities": 5369,
	"./cities.json": 5369,
	"./country": 5092,
	"./country.json": 5092,
	"./nasa_firms_all": 5309,
	"./nasa_firms_all.json": 5309,
	"./regions": 7995,
	"./regions.json": 7995,
	"./river": 1232,
	"./river.json": 1232,
	"./seas": 9126,
	"./seas.json": 9126,
	"./water": 8597,
	"./water.geojson": 5915,
	"./water.json": 8597,
	"./zoom": 8857,
	"./zoom.json": 8857,
	"./zoom_desktop": 2962,
	"./zoom_desktop.json": 2962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8565;